export default __webpack_public_path__ + "static/media/beans.2e520065.svg";